import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';


/**
 * Pipe transform class to convert numerical value in rounded values with respective currency and coloring
 */
@Pipe({
    name: 'rmsRoundRawNumber',
    standalone: false
})
export class RmsRoundRawNumberPipe implements PipeTransform {

  transform(value: any, colored = false, currency = 'USD'): string {
    const isNegative = value < 0 && colored ? 'text-danger' : value >= 0 && colored ? 'text-success' : '';
    return `<span class="${isNegative}">${getCurrencySymbol(currency, 'narrow')}${Math.round(value).toLocaleString('en-US')}</span>`;
  }

}
